{
  "UnifiedNavigation": "Navigate in the Experience Cloud",
  "adobeExperienceCloudNoOrgsSelect": "Select another org account",
  "help": "Help",
  "profile": "Profile",
  "searchButton": "Search",
  "sidenavMenuCloseTooltip": "Close menu",
  "sidenavMenuOpenTooltip": "Open menu",
  "solutionSwitcher": "Switch to another Solution",
  "toggleSideNav": "Toggle side navigation menu"
} 
